import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React, { Fragment } from 'react';
import { H4 } from '@finect/tabular-core/Headings';
import { FieldComponent } from '../FieldForm/FieldComponent';
import { TitleBlock, ComponentBlock } from './partials';
export var PillStep = function PillStep(_ref) {
  var field = _ref.field,
    value = _ref.value,
    onChange = _ref.onChange;
  var handleFieldChange = function handleFieldChange(eventValue) {
    onChange(eventValue);
  };
  return React.createElement(Fragment, null, React.createElement(TitleBlock, null, React.createElement(H4, null, field.description)), React.createElement(ComponentBlock, null, React.createElement(FieldComponent, {
    field: field,
    value: value,
    onChange: handleFieldChange,
    size: "medium"
  })));
};